import { SET_COUNT, CLEAR_COUNT } from './constants'

export default function reducer(state = 0, action) {
    switch (action.type) {
        case SET_COUNT: {
            if (state >= 5) return 1
            return state + 1
        }

        case CLEAR_COUNT: {
            return 0
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/display/reducer.js